import { GET_CAMPAIGN_HEATS_FOR_ASSET } from "~/constants/swrKey";
import { getCampaignHeatsForAsset } from "../services/copilot";
import { useSwrManagement } from "~/hooks/useSwrManagement";
import { compareWithTextSensitivity } from "~/helpers/compare";
import { mutate } from "swr";

const fetcher = async (assetId: string) => {
  const result = await getCampaignHeatsForAsset(assetId);

  const sortedResult = result.sort((a, b) => {
    const aCampDate = a.displayText.split(" ")[0];
    const bCampDate = b.displayText.split(" ")[0];
    const aHeat = a.displayText.split(" ")[1].replace("#", "");
    const bHeat = b.displayText.split(" ")[1].replace("#", "");

    return aCampDate > bCampDate
      ? -1
      : aCampDate == bCampDate
        ? compareWithTextSensitivity(aHeat, bHeat, "desc")
        : 1;
  });

  return sortedResult;
};

export const useGetCampaignHeatsForAsset = (assetId: string) => {
  const swrKey = createSWRKey(assetId);

  const { data, loading } = useSwrManagement({
    swrKey,
    fetcher: () => fetcher(assetId),
  });

  return {
    data,
    loading,
  };
};

const createSWRKey = (assetId: string) => {
  return `${GET_CAMPAIGN_HEATS_FOR_ASSET}-${assetId}`;
};

export const mutateCampaignHeatsForAsset = (assetId: string) => {
  const swrKey = createSWRKey(assetId);
  mutate(swrKey, () => fetcher(assetId));
};
